export enum TalkViewerErrorType {
  NoDecryptKey = 1,
  NoContentUrl,
  DecryptFail,
  NeedUpdate,
  AppError,
  NeedAppLogin,
  UnknownError,
}
